<template>
  <div style="width: 100%; background-color: #eaf1fa;">
    <div
      class="div-banner-item max-width-1920"
      :style="{backgroundImage: 'url('+ image +')'}"
    >
      <Header />
      <div class="bn-left" data-aos="fade-left">
        <div class="flexrow">
          <p>
            <span class="txtBig txtColorblack">{{ fontText.title }}</span>
          </p>
        </div>
        <div class="flexrow">
          <p class="txtMiddle">
            <span v-for="item in fontText.txtMiddle" :key="item"
              >{{ item }}<br
            /></span>
            <!-- 构建全流程、端到端、全产业全链路、<br />多行业的产业交易平台 -->
          </p>
        </div>
        <div v-if="fontText.flexrow">
          <div class="flexrow">
            <img src="@/assets/home/banner_check.svg" alt="" />
            <div class="txtSmall">
              构建产业互联统一平台，突破企业管理边界
            </div>
          </div>
          <div class="flexrow">
            <img src="@/assets/home/banner_check.svg" alt="" />
            <div class="txtSmall">
              以产业链上下游各环节交易数据为基础，有效连接需求端与供给端
            </div>
          </div>
          <div class="flexrow">
            <img src="@/assets/home/banner_check.svg" alt="" />
            <div class="txtSmall">
              通过开放共享系统架构，推动产业链上下游业务协同处理、交易实时反映、信息互联互通
            </div>
          </div>
          <div class="flexrow">
            <img src="@/assets/home/banner_check.svg" alt="" />
            <div class="txtSmall">
              实现政企、税企、银企、企企互联，促进产业协同发展，构建产业互联生态
            </div>
          </div>
        </div>
        <div class="flexrow">
          <button class="btn-get" @click="isModalVisible = true">获取方案详情</button>
        </div>
      </div>
    </div>
    <ContactUs @closeModal="closeModal" :isModalVisible="isModalVisible" v-if="isModalVisible" />
  </div>
</template>
<script>
import Header from "../../../components/Header";
import ContactUs from "@/components/ContactUs";
export default {
  name: "banner",
  components: {
    Header,
    ContactUs
  },
  props: {
    image: {
      type: String,
      default() {
        return "";
      },
    },
    fontText: {
      type: Object,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
    }
  },
};
</script>

<style lang="less" scoped>
.div-banner-item {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}
.div-banner-item .bn-left {
  width: 1200px;
  margin: auto;
  padding-top: 50px;
}
.div-banner-item .txtBig {
  font-weight: bold;
  font-size: 42px;
  line-height: 42px;
  text-align: left;
}

.div-banner-item .txtColorblack {
  color: #020814;
}

.div-banner-item .txtMiddle {
  /* font-weight: bold; */
  font-size: 30px;
  color: #222222;
  text-align: left;
  margin-top: 22px;
}

.div-banner-item .txtSmall {
  font-size: 14px;
  color: #3e4755;
  text-align: left;
  line-height: 29px;
  margin-left: 6px;
}

.div-banner-item .flexrow {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.div-banner-item .btn-get {
  background: #1763ff;
  color: #ffffff;
  width: 150px;
  height: 44px;
  border-radius: 4px;
  border: none;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
  &:hover{
    background: #2e72ff;
  }
}
</style>
